/* FDP Tips & Tricks carousel
 *
 * Each section is initialized from its own [data-tips-tricks-section] wrapper.
 * Do not use global video-block selectors here: the theme also contains the
 * FDP Video Block section, which has its own carousel implementation.
 */
(function (window, document) {
  'use strict';

  var existingApi = window.FDP_TipsTricksCarousel;

  if (existingApi) {
    existingApi.initAll(document);
    return;
  }

  var api = {};
  window.FDP_TipsTricksCarousel = api;

  function safePlay(video) {
    if (!video || typeof video.play !== 'function') return;

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        // Browsers can reject unmuted programmatic playback. A user click can
        // start it later, so this should not surface as an uncaught error.
      });
    }
  }

  function getActiveSlide(swiper) {
    return swiper && swiper.slides ? swiper.slides[swiper.activeIndex] : null;
  }

  function getSlideIndex(slide) {
    var swiperIndex = slide.getAttribute('data-swiper-slide-index');
    if (swiperIndex !== null) {
      return parseInt(swiperIndex, 10) || 0;
    }

    // Original section markup uses a one-based index. Swiper's slideToLoop
    // expects a zero-based real index.
    var sectionIndex = parseInt(slide.getAttribute('data-video-slide-index'), 10);
    return isNaN(sectionIndex) ? 0 : Math.max(0, sectionIndex - 1);
  }

  function loadThumbnailVideo(slide) {
    if (!slide) return null;

    var background = slide.querySelector('.video-block__background-photo[data-video]');
    if (!background) return null;

    var videoLoad = background.querySelector('.video-load');
    var videoUrl = background.getAttribute('data-video');
    if (!videoLoad || !videoUrl) return null;

    var video = videoLoad.querySelector('video');
    if (!video) {
      video = document.createElement('video');
      video.src = videoUrl;
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.playsInline = true;
      videoLoad.appendChild(video);
    }

    safePlay(video);
    return video;
  }

  function removeModalsExcept(carousel, allowedSlide) {
    var modals = carousel.querySelectorAll('.youtube-video-modal');

    Array.prototype.forEach.call(modals, function (modal) {
      if (!allowedSlide || !allowedSlide.contains(modal)) {
        modal.remove();
      }
    });
  }

  function pauseVideosExcept(carousel, allowedSlide) {
    var videos = carousel.querySelectorAll('video');

    Array.prototype.forEach.call(videos, function (video) {
      if (!allowedSlide || !allowedSlide.contains(video)) {
        video.pause();
      }
    });
  }

  function openModal(carousel, swiper, slide, youtubeId, videoFull, muted, enableLoop, replaceExisting) {
    if (!slide || (!youtubeId && !videoFull)) return;

    removeModalsExcept(carousel, slide);

    var existingModal = slide.querySelector('.youtube-video-modal');
    if (existingModal) {
      if (!replaceExisting) return;
      existingModal.remove();
    }

    var modal = document.createElement('div');
    modal.className = 'youtube-video-modal';

    var closeButton = document.createElement('button');
    closeButton.className = 'close-modal';
    closeButton.innerHTML = '<span></span>';
    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      modal.remove();
    });
    modal.appendChild(closeButton);

    if (youtubeId) {
      var isVerticalVideo = slide.classList.contains('vertical-video');
      var iframe = document.createElement('iframe');

      iframe.src = 'https://www.youtube-nocookie.com/embed/' + youtubeId + '?autoplay=1&si=' + (muted ? '&mute=1' : '');
      iframe.title = 'YouTube video player';
      iframe.frameBorder = '0';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.width = isVerticalVideo ? '720' : '1280';
      iframe.height = isVerticalVideo ? '1280' : '720';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      modal.appendChild(iframe);
    } else {
      var video = document.createElement('video');
      var background = slide.querySelector('.video-block__background-photo');
      var volume = background ? parseFloat(background.getAttribute('data-video-full-volume')) : NaN;

      video.src = videoFull;
      video.autoplay = true;
      video.playsInline = true;
      video.controls = true;
      video.style.width = '100%';
      video.style.height = '100%';
      video.style.objectFit = 'cover';
      video.muted = Boolean(muted);
      video.volume = isNaN(volume) ? 0.4 : volume;

      if (enableLoop) {
        video.addEventListener('ended', function () {
          modal.remove();
          swiper.slideNext();
        });
      }

      modal.appendChild(video);
      safePlay(video);
    }

    slide.appendChild(modal);
  }

  function initialiseViewportObserver(carousel, swiper, config) {
    function onViewportEntry() {
      if (swiper.destroyed) return;

      var images = carousel.querySelectorAll('img[datasrc]');
      Array.prototype.forEach.call(images, function (image) {
        image.setAttribute('src', image.getAttribute('datasrc'));
        image.removeAttribute('datasrc');
      });

      swiper._viewportTriggered = true;

      window.setTimeout(function () {
        if (swiper.destroyed) return;

        var activeSlide = getActiveSlide(swiper);
        var background = activeSlide && activeSlide.querySelector('.video-block__background-photo');

        loadThumbnailVideo(activeSlide);

        if (!config.enableAutoplay || !background) return;

        var youtubeId = background.getAttribute('data-youtube-id') || '';
        var videoFull = background.getAttribute('data-video-full') || '';

        if (youtubeId || videoFull) {
          swiper._autoplayActive = true;
          openModal(carousel, swiper, activeSlide, youtubeId, videoFull, true, config.enableLoop, false);
        }
      }, 100);
    }

    if (!('IntersectionObserver' in window)) {
      onViewportEntry();
      return;
    }

    var observer = new window.IntersectionObserver(function (entries) {
      Array.prototype.forEach.call(entries, function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          onViewportEntry();
        }
      });
    }, { threshold: 0 });

    observer.observe(carousel);
  }

  function initialiseSection(section) {
    if (!section || section.getAttribute('data-fdp-tips-tricks-initialized') === 'true') return;
    if (typeof window.Swiper === 'undefined') return;

    var carousel = section.querySelector('[data-tips-tricks-carousel]');
    if (!carousel) return;

    section.setAttribute('data-fdp-tips-tricks-initialized', 'true');

    var config = {
      enableAutoplay: carousel.getAttribute('data-enable-autoplay') === 'true',
      enableLoop: carousel.getAttribute('data-enable-loop') === 'true'
    };

    var swiper = new window.Swiper(carousel, {
      speed: 600,
      grabCursor: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      initialTransitionCount: 0,
      _viewportTriggered: false,
      _autoplayActive: false,
      on: {
        sliderMove: function () {
          this._userInteracted = true;
        },
        beforeTransitionStart: function () {
          if (this._viewportTriggered) {
            loadThumbnailVideo(getActiveSlide(this));
          }
        },
        transitionStart: function () {
          var activeSlide = getActiveSlide(this);
          removeModalsExcept(carousel, activeSlide);
          pauseVideosExcept(carousel, activeSlide);
        },
        transitionEnd: function () {
          var activeSlide = getActiveSlide(this);
          var background = activeSlide && activeSlide.querySelector('.video-block__background-photo');
          var handledByAutoplay = false;

          this.initialTransitionCount += 1;

          if (config.enableAutoplay) {
            var shouldAutoplayFull = this._autoplayActive || this._userInteracted;
            this._userInteracted = false;

            if (shouldAutoplayFull && this._viewportTriggered && background) {
              var youtubeId = background.getAttribute('data-youtube-id') || '';
              var videoFull = background.getAttribute('data-video-full') || '';

              if (youtubeId || videoFull) {
                this._autoplayActive = true;
                handledByAutoplay = true;
                openModal(carousel, this, activeSlide, youtubeId, videoFull, true, config.enableLoop, false);
              }
            }
          } else if (this._userInteracted && activeSlide && background) {
            this._userInteracted = false;
            var clickedYoutubeId = background.getAttribute('data-youtube-id') || '';
            var clickedVideoFull = background.getAttribute('data-video-full') || '';
            openModal(carousel, this, activeSlide, clickedYoutubeId, clickedVideoFull, false, false, true);
          }

          if (!handledByAutoplay) {
            safePlay(activeSlide && activeSlide.querySelector('video'));
          }
        },
        slideChangeTransitionEnd: function () {
          var pendingYoutubeId = carousel.getAttribute('data-pending-youtube-id');
          var pendingVideoFull = carousel.getAttribute('data-pending-video-full');

          if (!pendingYoutubeId && !pendingVideoFull) return;

          carousel.removeAttribute('data-pending-youtube-id');
          carousel.removeAttribute('data-pending-video-full');
          openModal(carousel, this, getActiveSlide(this), pendingYoutubeId, pendingVideoFull, false, false, true);
        }
      }
    });

    // Keep custom state on the real Swiper object. Some Swiper versions do
    // not preserve arbitrary options passed in the constructor configuration.
    swiper.initialTransitionCount = 0;
    swiper._viewportTriggered = false;
    swiper._autoplayActive = false;

    section._fdpTipsTricksSwiper = swiper;

    carousel.addEventListener('click', function (event) {
      var target = event.target.closest('.video-block__background-photo[data-youtube-id], .video-block__background-photo[data-video-full], .video-block__content');
      if (!target || !carousel.contains(target)) return;

      // The Video Block section has a legacy document-level click listener.
      // Stopping propagation makes this event private to this Tips & Tricks
      // instance and prevents it from controlling a Video Block carousel.
      event.stopPropagation();

      if (event.target.closest('.youtube-video-modal, .close-modal')) return;

      var background = target.classList.contains('video-block__background-photo')
        ? target
        : target.closest('.swiper-slide').querySelector('.video-block__background-photo');
      if (!background) return;

      var youtubeId = background.getAttribute('data-youtube-id') || '';
      var videoFull = background.getAttribute('data-video-full') || '';
      if (!youtubeId && !videoFull) return;

      var currentSlide = background.closest('.swiper-slide');
      if (currentSlide.classList.contains('swiper-slide-active')) {
        openModal(carousel, swiper, currentSlide, youtubeId, videoFull, false, false, true);
        return;
      }

      carousel.setAttribute('data-pending-youtube-id', youtubeId);
      carousel.setAttribute('data-pending-video-full', videoFull);
      swiper.slideToLoop(getSlideIndex(currentSlide));
    });

    initialiseViewportObserver(carousel, swiper, config);

    window.setTimeout(function () {
      if (!swiper.destroyed) swiper.update();
    }, 100);
  }

  api.initSection = initialiseSection;
  api.initAll = function (scope) {
    var root = scope || document;
    var sections = [];

    if (root.matches && root.matches('[data-tips-tricks-section]')) {
      sections.push(root);
    }

    Array.prototype.push.apply(sections, root.querySelectorAll('[data-tips-tricks-section]'));
    Array.prototype.forEach.call(sections, initialiseSection);
  };

  api.initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    api.initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.matches && event.target.matches('[data-tips-tricks-section]')
      ? event.target
      : event.target.querySelector('[data-tips-tricks-section]');
    var swiper = section && section._fdpTipsTricksSwiper;

    if (swiper && !swiper.destroyed) {
      swiper.destroy(true, true);
    }
  });
})(window, document);